import { faqs } from "@/mocks/events";

export default function Faq() {
  return (
    <section id="faq" className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
            <i className="ri-question-line text-sm"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于吃瓜时间线，你想知道的
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f) => (
            <details key={f.q} className="group rounded-2xl border border-background-200 bg-background-50 open:border-primary-200">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 p-5 text-left">
                <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform group-open:rotate-180">
                  <i className="ri-arrow-down-s-line text-xl"></i>
                </span>
              </summary>
              <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}